var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "ma-0 pa-2 mt-2",
      attrs: { width: "100%", elevation: "0", outlined: "" },
    },
    [
      _c("v-card-title", { staticClass: "blue--text pa-0 ma-0 ml-1 mb-2" }, [
        _vm._v("Spring"),
      ]),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4", sm: "4" } },
            [
              _c("r-range", {
                attrs: { model: _vm.value.shotImpulse, label: "Shot impulse" },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.value, "shotImpulse", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4", sm: "4" } },
            [
              _c("r-range", {
                attrs: {
                  model: _vm.value.shotDeviation,
                  label: "Shot Deviation",
                },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.value, "shotDeviation", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4", sm: "4" } },
            [
              _c("r-range", {
                attrs: {
                  model: _vm.value.touchImpulse,
                  label: "Touch impulse",
                },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.value, "touchImpulse", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "12", sm: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Exclude Impulse",
                  rules: [_vm.validator.points],
                  hint: "Example: 1;3;5",
                },
                model: {
                  value: _vm.value.excludeImpulseString,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.value,
                      "excludeImpulseString",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "value.excludeImpulseString",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }